import React, { useEffect, useState } from "react";
import TableComponent from "../../../helpersComponents/TableComponent/tableComponent";
import { useTranslation } from "react-i18next";
import DatePickerRange from "../../../helpersComponents/DatePickerRange/datePickerRange";
import { Table } from "@devexpress/dx-react-grid-material-ui";
import { TopBanner } from "../../../helpersComponents/TopBanner/topBanner";
import { selectAuthUser } from "../../../../reducers/session";
import { useAppSelector } from "../../../../store/hooks";
import useFetch from "../../../../hooks/fetchHooks/useFetch/useFetch";
import convertDateFetch from "../../../../HelpersFunctions/dateAndTime/convertDateFetch";
import getBeginningOfDate from "../../../../HelpersFunctions/dateAndTime/getBeginningOfDate";
import getEndOfDate from "../../../../HelpersFunctions/dateAndTime/getEndOfDate";
import compareDatesIgnoringTime from "../../../../HelpersFunctions/dateAndTime/compareDatesIgnoringTime";
import { CheckboxStyled } from "../../../helpersComponents/MaterialUi";
import { FormControlLabel } from "@material-ui/core";
import styles from "./absenceOfCoworkers.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

let TableCell: any = Table.Cell;

const TableCellComponent = ({ value, style, ...restProps }: any) => {
  let cellStyles = {};
  let cellValue;
  if (
    restProps.column.name === "name" ||
    restProps.column.name === "organizationalUnits"
  ) {
    cellValue = value;
  } else {
    cellValue = value?.dayName;
    cellStyles = { textAlign: "center" };
  }

  return (
    <TableCell
      {...restProps}
      style={{
        backgroundColor: value?.color,
        ...cellStyles,
        ...style,
      }}
      className={styles.borderLeft}
    >
      <span>{cellValue}</span>
    </TableCell>
  );
};

function AbsenceOfCoworkersContent() {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(
    getBeginningOfDate(new Date(), "Month")
  );
  const [endDate, setEndDate] = useState(getEndOfDate(new Date(), "Month"));
  const authUserId = useAppSelector(selectAuthUser).currentProfile.subjectId;

  const [onlyRequests, setOnlyRequests] = useState<boolean>(false);
  let [setIsFetching, fetchingState, fetchAgain, clearData] = useFetch({
    method: "GET",
    path: `worker-time/${authUserId}/coworkers-absences?dateFrom=${convertDateFetch(
      startDate
    )}&dateTo=${convertDateFetch(
      getEndOfDate(startDate, "Month")
    )}&OnlyRequests=${onlyRequests}`,
    startFetchOnInitial: false,
  });

  useEffect(() => {
    setEndDate(getEndOfDate(startDate, "Month"));
    fetchAgain();
  }, [fetchAgain, startDate, onlyRequests]);

  const [rows, setRows] = useState<any[]>([]);
  const [columns, setColumns] = useState<{ name: string; title: string }[]>([]);

  useEffect(() => {
    if (fetchingState.isError || fetchingState.response === undefined) return;
    if (!Array.isArray(fetchingState.response.resJson)) return;
    let data = fetchingState.response.resJson;
    console.log(data);
    let columnsLocal: { name: string; title: string }[] = [
      { name: "name", title: t("name") },
      { name: "organizationalUnits", title: t("organizational_units") },
    ];
    let rowsLocal: any[] = [];
    let startDay = startDate.getDate();
    let endDay = endDate.getDate();

    /////////////////////////////////// create columns
    for (let i = startDay; i <= endDay; i++) {
      let currentIterationDate = new Date(startDate);
      currentIterationDate.setDate(i);
      let dayTitleString = `${i} ${currentIterationDate.toLocaleString(
        t("scheduler_language"),
        {
          weekday: "short",
        }
      )}`;
      columnsLocal.push({ name: i.toString(), title: dayTitleString });
    }

    //////////////////////////////// create rows
    data.forEach((worker) => {
      let row = {
        id: worker.timeWorkerId,
        name: `${worker.firstName} ${worker.lastName}`,
        organizationalUnits: worker.organizationalUnit,
      };
      for (let i = startDay; i <= endDay; i++) {
        let currentIterationDate = new Date(startDate);
        currentIterationDate.setDate(i);
        let daydata = worker.absences.find((absence) => {
          return compareDatesIgnoringTime(
            new Date(absence.date),
            currentIterationDate
          );
        });
        row[i] = daydata;
      }
      rowsLocal.push(row);
    });

    setRows(rowsLocal);
    setColumns(columnsLocal);
    setIsFetching(false);
    clearData();
  }, [
    fetchingState.isError,
    endDate,
    startDate,
    fetchingState.response,
    setIsFetching,
    clearData,
    t,
  ]);

  return (
    <>
      <TopBanner pathName={t("absences_of_coworkers")} />
      <div className="flexAndCenter">
        <div>
          <DatePickerRange
            view={["year", "month", "date"]}
            format="dd-MM-yyyy"
            date={startDate}
            date2={endDate}
            setDate={setStartDate}
            setDate2={setEndDate}
            darkTheme={true}
            confirmButtonRight={
              <div className={styles.datepickerOptions}>
                <div className={styles.changeDateArrows}>
                  <div
                    onClick={() => {
                      let startDateLocal = new Date(startDate);
                      startDateLocal.setMonth(startDateLocal.getMonth() - 1);
                      setStartDate(startDateLocal);
                    }}
                  >
                    <FontAwesomeIcon
                      className={styles.faAngleArrow}
                      icon={faAngleLeft}
                    />
                  </div>
                  <div
                    onClick={() => {
                      let startDateLocal = new Date(startDate);
                      startDateLocal.setMonth(startDateLocal.getMonth() + 1);
                      setStartDate(startDateLocal);
                    }}
                  >
                    <FontAwesomeIcon
                      className={styles.faAngleArrow}
                      icon={faAngleRight}
                    />
                  </div>
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <CheckboxStyled
                        checked={onlyRequests}
                        name="active"
                        onChange={() => {
                          setOnlyRequests(!onlyRequests);
                        }}
                      />
                    }
                    label={
                      <span className={styles.checkboxLabel}>
                        {t("only_requests")}
                      </span>
                    }
                  />
                </div>
              </div>
            }
            disabledSecond={true}
          ></DatePickerRange>
        </div>
        <div>
          <TableComponent
            layoutSettingName="layoutWorkerTimeSummaryAnnualRecords"
            rows={rows}
            columns={columns}
            tableCellComponent={TableCellComponent}
            fetchingState={{
              isError: fetchingState.isError,
              isFetching: fetchingState.isFetching,
              fetchAgain: fetchAgain,
            }}
          />
        </div>
      </div>
    </>
  );
}

export default AbsenceOfCoworkersContent;
